<template>
  <div class="mt-2">
    <!-- VALOR SEM DESCONTO -->
    <div v-if="discount">
      <span
        class="riskText"
        v-bind:class="[origin == out ? 'fora ' : ' colorBlack']"
      >
        {{ quote[0].cot_valor_total }}
      </span>
      <span class="badge badge-light bg-success text-white">
        <!-- <i class="fa-solid fa-arrow-down"></i>  -->
        {{ discount }}%</span
      >
    </div>

    <!-- VALOR COM DESCONTO -->
    <div v-if="money > 0">
      <h5 v-bind:class="[origin == out ? 'fora money' : 'colorBlack cash']">
        <strong>
          {{
            money.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
          }}
        </strong>
      </h5>
    </div>

    <!-- CARTÃO -->
    <div v-if="installments != 0">
      <p v-bind:class="[origin == out ? 'fora ' : ' colorBlack']">
        <i
          class="far fa-credit-card"
          v-bind:class="[origin == out ? 'fs-15 ' : '']"
        ></i>
        até {{ installments }}x de
        {{
          installmentsValue.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
        }}*
      </p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    idQuote: {
      required: true,
    },
    origin: {
      type: String,
      require: false,
    },
  },
  data() {
    return {
      cardValue: 0,
      installments: 0,
      installmentsValue: 0,
      money: 0,
      discount: '',
      quote: [],
      out: ''
    };
  },

  created() {
    this.get();
  },
  methods: {
    get() {
      this.$store.dispatch('showValueQuote', this.idQuote).then((response) => {
        this.quote = response.data.data;
        this.calcValues();

      });
    },

    calcValues() {
      let payment = this.quote;
      let valor = this.quote[0].cot_valor_total_sem_mascara;
      let quoteValue = valor / 100;
      let boleto;
      let pix;
      let cartao;
      let descontoPix;
      let descontoBoleto;
      let descontoCartao;
      let pixValue = 0;
      let ticketValue = 0;

      //vendo as formas de pagamento
      payment[0].formas_pagamentos.forEach((formaPagamento) => {
        if (formaPagamento.forma_de_pagamento == 'P') {
          pix = formaPagamento.forma_de_pagamento;
          descontoPix = formaPagamento.desconto / 100;
        }
        if (formaPagamento.forma_de_pagamento == 'B') {
          boleto = formaPagamento.forma_de_pagamento;
          descontoBoleto = formaPagamento.desconto / 100;
        }
        if (formaPagamento.forma_de_pagamento == 'C') {
          cartao = formaPagamento.forma_de_pagamento;
          descontoCartao = formaPagamento.desconto / 100;
          this.installments = formaPagamento.parcela;
        }
      });

      // aplicando os descontos
      if (pix) {
          pixValue = quoteValue - quoteValue * descontoPix;
      }
      if (boleto) {
        ticketValue = quoteValue - quoteValue * descontoBoleto;
      }
      if (cartao != "") {
        this.cardValue = quoteValue - (quoteValue * descontoCartao);
        this.installmentsValue = this.cardValue / this.installments;
      }

      //pegando o menor valor
      if (pixValue > 0 && ticketValue > 0) {
        if (pixValue < ticketValue) {
          this.money = pixValue;
          this.discount = parseInt(descontoPix * 100);
        } else {
          this.money = ticketValue;
          this.discount = parseInt(descontoBoleto * 100);
        }
      } 
      else if (pixValue > 0) {
        this.money = pixValue;
        this.discount = parseInt(descontoPix * 100);
      } 
      else if (ticketValue > 0) {
        this.money = ticketValue;
        this.discount = parseInt(descontoBoleto * 100);
      }
      else{
        this.money = this.cardValue;
      }
    },
  },
};
</script>

<style scoped>
.riskText {
  text-decoration: line-through;
}
.colorBlack {
  color: black;
}
.fora {
  font-size: 12px;
}
.money {
  font-size: large;
}
.cash {
  font-size: 30px;
}

</style>